<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-4">
        <div class="card">
          <div class="card-body">
            <div class="headline_under">
              <feather type="file-text" class="small-icon"></feather>
              <div class="v-super" @click="debug">Kundendaten</div>
            </div>
            <div class="form-container">
              <label>Vorname*</label>
              <b-input-group class="form-input-group" prepend="Abc">
                <b-form-input
                  class="form-control"
                  name="first_name"
                  v-model="first_name"
                  @blur="validate"
                  v-bind:class="{ form_error: hasError('first_name') }"
                ></b-form-input>
              </b-input-group>
              <label>Nachname*</label>
              <b-input-group class="form-input-group" prepend="Abc">
                <b-form-input
                  class="form-control"
                  name="last_name"
                  v-model="last_name"
                  @blur="validate"
                  v-bind:class="{ form_error: hasError('last_name') }"
                ></b-form-input>
              </b-input-group>
              <label>Telefon</label>
              <b-input-group class="form-input-group" prepend="123">
                <b-form-input class="form-control" name="telefon" v-model="telefon"></b-form-input>
              </b-input-group>
              <label>Email*</label>
              <b-input-group class="form-input-group" prepend="@">
                <b-form-input
                  class="form-control"
                  name="email"
                  v-model="email"
                  @blur="validate"
                  v-bind:class="{ form_error: hasError('email') }"
                ></b-form-input>
              </b-input-group>             
              <b-input-group>                
                <input type="checkbox" value="true" unchecked-value="false" v-model="sendMail" style="position:relative; top:4px;">
                 <label style="margin-left:5px;">Password Mail schicken?</label>
              </b-input-group>
            </div>
          </div>
          <b-button @click="createKunde">Kunde erstellen</b-button>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="card">
          <div class="card-body">
            <div class="headline_under">
              <feather type="map" class="small-icon"></feather>
              <div class="v-super">Anschrift</div>
            </div>
            <div class="form-container">
              <label>Strasse</label>
              <b-input-group class="form-input-group" prepend="Abc">
                <b-form-input class="form-control" name="strasse" v-model="strasse"></b-form-input>
              </b-input-group>
              <label>Ort</label>
              <b-input-group class="form-input-group" prepend="Abc">
                <b-form-input class="form-control" name="ort" v-model="ort"></b-form-input>
              </b-input-group>
              <label>PLZ</label>
              <b-input-group class="form-input-group" prepend="123">
                <b-form-input class="form-control" name="plz" v-model="plz"></b-form-input>
              </b-input-group>
              <label>Beschreibung</label>
              <b-input-group class="form-input-group">
                <textarea rows="3" class="form-control" name="beschreibung" v-model="beschreibung" />
              </b-input-group>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="card">
          <div class="card-body">
            <div class="headline_under">
              <feather type="map" class="small-icon"></feather>
              <div class="v-super">Kundenbild</div>
            </div>
            <vue-dropzone
              ref="kundenbild_dropzone"
              :options="kundenbild_dropzone_options"
              id="kundenbild_dropzone"
              class
              v-on:vdropzone-file-added="processUploadState"
              v-on:vdropzone-success="processAsset"
            ></vue-dropzone>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <div class="headline_under">
              <feather type="map" class="small-icon"></feather>
              <div class="v-super">Wohnungen zuordnen</div>
              <div class="icon-clickable-right" @click="showModalWohnungen">
                <feather type="plus"></feather>
              </div>
            </div>
            <div class="default-table" v-if="selectedWohnungen.length">
              <div class="default-table-legend">
                <div>Wohnung</div>
                <div>Haus</div>
                <div>Bauprojekt</div>
              </div>
              <div class="default-table-row" v-for="wohnung in selectedWohnungen" :key="wohnung.id">
                <div>{{ wohnung.name }}</div>
                <div>{{ wohnung.haus.name }}</div>
                <div>{{ wohnung.bauprojekt.name }}</div>
              </div>
            </div>
          </div>
        </div>
        <b-modal size="xl" id="assignWohnung" @ok="updateSelectedWohnungen">
          <div class="container-fluid">
            <div class="row">
              <div class="col-10" style="margin:0 auto;">
                <transition
                  :name="animations.standard.name"
                  :enter-active-class="animations.standard.enter"
                  :leave-active-class="animations.standard.leave"
                  mode="out-in"
                >
                  <div class="select-bauprojekt-container" v-if="modalStep == 0" key="stepOne">
                    <div
                      @click="selectBauprojekt(bp.id)"
                      class="bauprojekt-button"
                      v-for="bp in bauprojekte"
                      :key="bp.id"
                      :class="{ selected_bauprojekt: modalSelectedBauprojekt == bp.id }"
                    >
                      {{ bp.name }}
                      <span v-if="howManySelected(bp.id, 'bauprojekt')" class="badge badge-secondary">{{
                        howManySelected(bp.id, "bauprojekt")
                      }}</span>
                    </div>
                  </div>
                  <div key="stepTwo" v-if="modalStep == 1">
                    <div v-if="!modalSelectedBauprojekt.hauser">
                      <div style="margin-bottom:20px;">Keine Häuser im Bauprojekt gefunden.</div>
                    </div>
                    <div class="select-haus-container" v-if="modalSelectedBauprojekt.hauser">
                      <div v-for="haus in modalSelectedBauprojekt.hauser" :key="haus.id" class="haus-button" @click="selectHaus(haus.id)">
                        {{ haus.name }}
                        <span v-if="howManySelected(haus.id, 'haus')" class="badge badge-secondary">{{ howManySelected(haus.id, "haus") }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="select-wohnung-container" key="stepThree" v-if="modalStep == 2">
                    <div v-if="modalSelectedHaus.wohnungen.length == 0">
                      <div style="margin-bottom:20px;">Keine Wohnungen gefunden oder alle Wohnungen reserviert.</div>
                    </div>
                    <div
                      v-for="wohnung in modalSelectedHaus.wohnungen"
                      :key="wohnung.id"
                      class="wohnung-button"
                      :class="{ selected: isSelectedWohnung(wohnung.id) }"
                      @click="selectWohnung(wohnung)"
                    >
                      {{ wohnung.name }}
                      <feather class="selected_check" type="check"></feather>
                    </div>
                  </div>
                </transition>
              </div>
            </div>
          </div>
          <template v-slot:modal-header>
            <div class="container-fluid">
              <div class="row">
                <div
                  class="u-pearl col-4 progress_pearl"
                  :class="{ current: modalStep == 0, done: modalStep == 1 || modalStep == 2 }"
                  id="stepOne"
                  ref="stepOne"
                >
                  <span class="u-pearl-number">1</span>
                  <transition
                    :name="animations.standard.name"
                    :enter-active-class="animations.standard.enter"
                    :leave-active-class="animations.standard.leave"
                    mode="out-in"
                  >
                    <span v-if="!modalSelectedBauprojekt.name" class="u-pearl-title" key="bpchoose">Bauprojekt wählen</span>
                    <span v-if="modalSelectedBauprojekt.name" class="u-pearl-title" key="bpchosen"
                      >Bauprojekt: {{ modalSelectedBauprojekt.name }}</span
                    >
                  </transition>
                </div>
                <div class="u-pearl col-4 progress_pearl" :class="{ current: modalStep == 1, done: modalStep == 2 }" id="stepTwo" ref="stepTwo">
                  <span class="u-pearl-number">2</span>
                  <transition
                    :name="animations.standard.name"
                    :enter-active-class="animations.standard.enter"
                    :leave-active-class="animations.standard.leave"
                    mode="out-in"
                  >
                    <span v-if="!modalSelectedHaus.name" class="u-pearl-title" key="hauschoose">Haus wählen</span>
                    <span v-if="modalSelectedHaus.name" class="u-pearl-title" key="hauschosen">Haus: {{ modalSelectedHaus.name }}</span>
                  </transition>
                </div>
                <div class="u-pearl col-4 progress_pearl" :class="{ current: modalStep == 2 }" id="stepThree" ref="stepThree">
                  <span class="u-pearl-number">3</span>
                  <span class="u-pearl-title">Wohnung wählen</span>
                </div>
              </div>
            </div>
            <feather type="x" class="pointer" @click="resetModalState"></feather>
          </template>
          <template v-slot:modal-footer>
            <transition
              :name="animations.standard.name"
              :enter-active-class="animations.standard.enter"
              :leave-active-class="animations.standard.leave"
            >
              <b-button v-if="modalStep > 0" @click="stepBack(modalStep)">Zurück</b-button>
            </transition>
            <b-button @click="resetModalState">Abbrechen</b-button>
            <b-button @click="updateSelectedWohnungen">Speichern</b-button>
          </template>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import vue2Dropzone from "vue2-dropzone";

export default {
  name: "AdminNewKunde",
  data() {
    return {
      first_name: "",
      last_name: "",
      telefon: "",
      email: "",
      strasse: "",
      ort: "",
      plz: "",
      beschreibung: "",
      kundenbild: "",
      validation_errors: [],
      validation_success: [],
      dzThumbSize: 200,
      modalStep: 0,
      sendMail: "true",
      modalSelectedBauprojekt: {
        name: false,
        id: false,
        index: false,
        hauser: false,
      },
      modalSelectedHaus: {
        name: false,
        id: false,
        index: false,
        wohnungen: false,
      },
      modalSelectedWohnungen: [],
      selectedWohnungen: [],
      defaultBauprojekt: {
        name: false,
        id: false,
        index: false,
        hauser: false,
      },
      defaultHaus: {
        name: false,
        id: false,
        index: false,
        wohnungen: false,
      },
    };
  },
  components: {
    vueDropzone: vue2Dropzone,
  },
  computed: {
    ...mapGetters({
      bauprojekte: "app/bauprojekte",
      api: "auth/apiSettings",
      toast: "app/toasts",
      hauser: "app/hauser",
      wohnungen: "app/wohnungen",
      animations: "app/animations",
    }),
  },
  created: async function() {
    //kundenbild dropzone
    this.kundenbild_dropzone_options = {
      url: this.api.customUploads,
      thumbnailMethod: "contain",
      thumbnailWidth: this.dzThumbSize,
      maxFiles: 1,
      init: function() {
        this.on("maxfilesexceeded", function(file) {
          this.removeAllFiles();
          this.addFile(file);
        });
      },
      dictDefaultMessage:
        '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-upload-cloud"><polyline points="16 16 12 12 8 16"></polyline><line x1="12" y1="12" x2="12" y2="21"></line><path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"></path><polyline points="16 16 12 12 8 16"></polyline></svg>',

      headers: {
        Authorization: "bearer " +  await this.$directus.auth.token,
        "Cache-Control": null,
        "X-Requested-With": null,
      },
    };

    //tg_keller_plan dropzone
    this.tg_keller_plan_dropzone_options = {
      url: this.api.customUploads,
      thumbnailMethod: "contain",
      thumbnailWidth: this.dzThumbSize,
      maxFiles: 1,
      init: function() {
        this.on("maxfilesexceeded", function(file) {
          this.removeAllFiles();
          this.addFile(file);
        });
      },
      dictDefaultMessage:
        '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-upload-cloud"><polyline points="16 16 12 12 8 16"></polyline><line x1="12" y1="12" x2="12" y2="21"></line><path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"></path><polyline points="16 16 12 12 8 16"></polyline></svg>',

      headers: {
        Authorization: "bearer " +  await this.$directus.auth.token,
        "Cache-Control": null,
        "X-Requested-With": null,
      },
    };
  },
  methods: {
    howManySelected(id, type) {
      const selected = this.modalSelectedWohnungen.filter((wohnung) => wohnung[type].id == id);
      return selected.length;
    },
    showModalWohnungen() {
      this.modalSelectedWohnungen = JSON.parse(JSON.stringify(this.selectedWohnungen));
      this.$bvModal.show("assignWohnung");
    },
    selectBauprojekt(bauprojekt_id) {
      const bauprojekt_index = this.bauprojekte.findIndex((bp) => bp.id == bauprojekt_id);
      this.modalSelectedBauprojekt.id = bauprojekt_id;
      this.modalSelectedBauprojekt.name = this.bauprojekte[bauprojekt_index].name;
      this.modalSelectedBauprojekt.index = bauprojekt_index;
      this.modalStep = 1;
      if ("undefined" !== typeof this.bauprojekte[bauprojekt_index].extended.hauser && this.bauprojekte[bauprojekt_index].extended.hauser.length)
        this.modalSelectedBauprojekt.hauser = this.bauprojekte[bauprojekt_index].extended.hauser;
    },
    selectHaus(id) {
      const haus_index = this.bauprojekte[this.modalSelectedBauprojekt.index].extended.hauser.findIndex((haus) => haus.id == id);
      const haus_obj = this.bauprojekte[this.modalSelectedBauprojekt.index].extended.hauser.find((haus) => haus.id == id);
      this.modalSelectedHaus.index = haus_index;
      this.modalSelectedHaus.name = haus_obj.name;
      this.modalSelectedHaus.id = haus_obj.id;
      this.modalStep = 2;
      this.modalSelectedHaus.wohnungen = [];
      //assign all wohnungen which are "verfügbar" to the possible selection
      if ("undefined" !== typeof haus_obj.extended.wohnungen && haus_obj.extended.wohnungen.length)
        this.modalSelectedHaus.wohnungen = haus_obj.extended.wohnungen.filter((wohnung) => wohnung.status == "verfügbar");
    },
    selectWohnung(wohnung) {
      const wohnung_selection = {
        name: wohnung.name,
        id: wohnung.id,
        haus: {
          name: this.modalSelectedHaus.name,
          id: this.modalSelectedHaus.id,
        },
        bauprojekt: {
          name: this.modalSelectedBauprojekt.name,
          id: this.modalSelectedBauprojekt.id,
        },
      };
      const isSelected = this.modalSelectedWohnungen.findIndex((woh) => woh.id == wohnung_selection.id);
      if (isSelected > -1) this.modalSelectedWohnungen.splice(isSelected, 1);
      if (isSelected == -1) this.modalSelectedWohnungen.push(wohnung_selection);
    },
    stepBack(step) {
      switch (step) {
        case 1:
          this.modalSelectedHaus = this.defaultHaus;
          this.modalStep = 0;
          break;
        case 2: {
          this.modalStep = 1;
          break;
        }
      }
    },
    isSelectedWohnung(id) {
      return this.modalSelectedWohnungen.findIndex((wohnung) => wohnung.id == id) > -1 ? true : false;
    },
    resetModalState() {
      this.modalSelectedBauprojekt = this.defaultBauprojekt;
      this.modalSelectedHaus = this.defaultHaus;
      this.modalSelectedWohnungen = [];
      this.modalStep = 0;
      this.$bvModal.hide("assignWohnung");
    },
    updateSelectedWohnungen() {
      this.selectedWohnungen = JSON.parse(JSON.stringify(this.modalSelectedWohnungen));
      this.$bvModal.hide("assignWohnung");
      this.resetModalState();     
    },
    async saveWohnungRelation() {
      //abort if there are no selected wohnungen
      if (!this.selectedWohnungen.length) return;

      //prepare the payload for the relations
      const allKundeWohnungen = this.selectedWohnungen.map((woh) => {
        const result = {
          kunde: this.kunde_id,
          wohnung: woh.id,
        };
        return result;
      });

      const createKuWoRelation = {
        collection: "kunde_wohnung",
        items: allKundeWohnungen,
      };

      //set selected Wohnungen to "reserviert"
     /* const statusReservedWohnungen = this.selectedWohnungen.map( woh => {
         const result = {
           id: woh.id,
           status: "reserviert"
         }
         return result;
      });*/

      const statusReservedPayload = {
        collection: "wohnung",
        ids: this.selectedWohnungen,
        change: {status: "reserviert"}
      }

      try {
        await this.$store.dispatch("app/createMultiple", createKuWoRelation);
        await this.$store.dispatch("app/updateMultiple", statusReservedPayload);
      } catch (error) {
        this.$toasted.show("Fehler beim Speichern der zugeordneten Wohnungen", this.toast.failure);
      }
    },
    processUploadState() {
      return true;
    },
    processAsset(response = null, data = null) {
      //handle error / success of upload
      if (!response.xhr.status == 200) {
        this.$toasted.show("Fehler beim Upload", this.toast.error);
        return;
      }
      this.$toasted.show(data.data.filename_download + " Datum.", this.toast.success);

      //check what type of asset was uploaded
      const asset_type = response.previewElement.parentNode.id.split("_")[0];

      //tag the item in directus with the correct asset type
      this.$directus.updateItem("directus_files", data.data.id, {
        tags: [asset_type, "draft"],
      });
      this[asset_type] = data.data.id;
      return true;
    },
    hasError(field) {
      return this.validation_errors.indexOf(field) > -1 ? true : false;
    },
    async validate(field, mode = "default") {
      let fieldName;
      if (mode == "default") fieldName = field.target.name;
      if (mode == "manual") fieldName = field.field;
      const errorExists = this.validation_errors.indexOf(fieldName);
      const validationExists = this.validation_success.indexOf(fieldName);
      if (errorExists > -1) this.validation_errors.splice(errorExists, 1);
      if (validationExists > -1) this.validation_success.splice(validationExists, 2);

      const validationPayload = {
        context: "kunden",
        field: fieldName,
        value: this[fieldName],
      };

      const validation_result = await this.$store.dispatch("app/validateField", validationPayload);
      if (!validation_result) this.validation_errors.push(fieldName);
      if (validation_result) this.validation_success.push(fieldName);
      return validation_result;
    },
    async createKunde() {
      //check if the required fields contain valid values
      //set up validation payloads
      const first_name = {
        context: "kunden",
        field: "first_name",
        value: this.firstName,
      };

      const last_name = {
        context: "kunden",
        field: "last_name",
        value: this.last_name,
      };

      const email = {
        context: "kunden",
        field: "email",
        value: this.email,
      };

      //perform validatin for required fields
      const validateFirstName = await this.validate(first_name, "manual");
      const validateLastName = await this.validate(last_name, "manual");
      const validateEmail = await this.validate(email, "manual");

      //if any of the validations fails, return
      if (!validateFirstName || !validateLastName || !validateEmail) return;

      //create user payload
      const password = await this.$store.dispatch("app/generatePassword");
      let wohnungen = this.selectedWohnungen.map((wohnung) => {
        return wohnung.id;
      });

      const createKundePayload = {
        first_name: this.first_name,
        last_name: this.last_name,
        email: this.email,
        password: password,
        status: "active",
        role: 2,
        wohnungen,
        telefon: this.telefon,
        strasse: this.strasse,
        ort: this.ort,
        plz: this.plz,
        beschreibung: this.beschreibung,
        image: this.kundenbild,
        sendMail: this.sendMail,
      };

      //create the kunde
      try {
        await this.$store.dispatch("app/createKunde", createKundePayload);
        this.saveWohnungRelation();
        await this.$store.dispatch("app/apiGetKunden");
        this.$router.push("/admin/dashboard/kunden");
      } catch (error) {
        this.$swal({
          title: "Fehler",
          text: error,
          type: "error",
        });
      }
    },
    async debug() {
      const allRoles = await this.$directus.roles;
      console.log(allRoles);
    },
  },
};
</script>

<style>
#kundenbild_dropzone {
  min-height: 200px !important;
}

#kundenbild_dropzone .dz-default.dz-message {
  max-width: 100% !important;
}

.progress_pearl {
  display: inline;
}
.select-bauprojekt-container,
.select-haus-container {
  display: flex;
  flex-flow: row;
  flex-wrap: wrap;
  margin: 0 auto;
  justify-content: space-between;
  margin-top: 20px;
}
.bauprojekt-button,
.haus-button,
.wohnung-button {
  position: relative;
  border: 1px solid grey;
  padding: 20px;
  margin-bottom: 10px;
  cursor: pointer;
  width: 32.5%;
  text-align: center;
}

.selected_bauprojekt,
.selected_haus {
  background: red;
}

.wohnung-button .selected_check {
  visibility: hidden;
  position: absolute;
  right: 20px;
}

.wohnung-button.selected .selected_check {
  visibility: visible;
}
</style>
